import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const QuillEditor = ({ name, value, onChange, error, height = "200px" ,disable=false}) => {
  return (
    <div>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={(content) => onChange(name, content)} // Pass field name to the handler
        style={{ height, marginBottom: "60px" }}
        readOnly={disable}
        modules={disable ? { toolbar: false } : undefined}
      />
      {error && <p className="text-danger mt-2">{error}</p>}
    </div>
  );
};

export default QuillEditor;
